import { cloneDeep, isEmpty, map, set } from "lodash";
import { useEffect, useRef } from "react";
import { ChatAssistantNode } from "./ChatAssistantNode";
import styles from "./ChatContent.module.scss";
import { ChatTips } from "./ChatTips";
import { ChatUserNode } from "./ChatUserNode";
import React from "react";
export function ChatContent(props) {
  var chatListUpdateCountRef = useRef(0);
  var messageListRef = useRef(null);
  useEffect(function () {
    scrollToBottom();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.chatList]);
  function scrollToBottom() {
    props.onRefreshHeight();
  }
  useEffect(function () {
    var _props$textAreaValueC;
    if ((_props$textAreaValueC = props.textAreaValueChatList) !== null && _props$textAreaValueC !== void 0 && _props$textAreaValueC.length) {
      chatListUpdateCountRef.current = chatListUpdateCountRef.current + 1;
    }
  }, [props.textAreaValueChatList]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.messageList,
    ref: messageListRef
  }, /*#__PURE__*/React.createElement(ChatTips, {
    onLinkClicked: function onLinkClicked() {
      return props.onLinkClicked();
    }
  }), map(props.AssistantDefaultList, function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: item + index,
      className: styles.messageItem
    }, /*#__PURE__*/React.createElement(ChatAssistantNode, {
      showMask: true,
      isLast: false,
      isError: false,
      disabledStream: true,
      message: item,
      onRegenerateClicked: function onRegenerateClicked() {
        return props.onRegenerateClicked();
      }
    }));
  }), map(props.chatList, function (item, index, array) {
    var nextItem = undefined;
    if (index < props.chatList.length) {
      nextItem = props.chatList[index + 1];
    }
    if (item.type === "Assistant") {
      var isLast = array.length - 1 === index;
      // use streaming only the latest chat item and exclude first props loading
      var disabledStream = !isLast && !props.isShare && chatListUpdateCountRef.current > 1;
      return /*#__PURE__*/React.createElement("div", {
        key: "".concat(item.value).concat(index),
        className: styles.messageItem
      }, /*#__PURE__*/React.createElement(ChatAssistantNode, {
        showMask: nextItem === undefined || nextItem.type === "User",
        isLast: isLast,
        disabledStream: disabledStream,
        isError: false,
        message: item.value,
        isStreamStopped: props.isStreamStopped,
        onRegenerateClicked: function onRegenerateClicked() {
          props.onRegenerateClicked();
        },
        onStreamingContentChanged: function onStreamingContentChanged() {
          return scrollToBottom();
        },
        onStreamingContentStopped: function onStreamingContentStopped(value) {
          if (!isEmpty(value)) {
            var _chatList = cloneDeep(props.isShare ? props.chatList : props.textAreaValueChatList);
            set(_chatList, index, value);
            props.onStreamingContentStopped(_chatList);
          } else {
            props.onStreamingContentStopped();
          }
          scrollToBottom();
        }
      }));
    }
    if (item.type === "Error") {
      return /*#__PURE__*/React.createElement("div", {
        key: "".concat(item.value).concat(index),
        className: styles.messageItem
      }, /*#__PURE__*/React.createElement(ChatAssistantNode, {
        showMask: false //{nextItem === undefined || nextItem.type === "User"}
        ,
        disabledStream: true,
        isError: true,
        isLast: array.length - 1 === index,
        message: item.value,
        onRegenerateClicked: function onRegenerateClicked() {
          return props.onRegenerateClicked();
        }
      }));
    }
    if (item.type === "User") {
      return /*#__PURE__*/React.createElement("div", {
        key: "".concat(item.value).concat(index),
        className: styles.messageItem
      }, /*#__PURE__*/React.createElement(ChatUserNode, {
        showMask: nextItem === undefined || nextItem.type === "Error" || nextItem.type === "Assistant",
        message: item.value
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      key: item.value
    });
  }));
}